import { render, staticRenderFns } from "./VueRecaptcha.vue?vue&type=template&id=2a2c51f2&"
import script from "./VueRecaptcha.vue?vue&type=script&lang=js&"
export * from "./VueRecaptcha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports